/**
 * CardSection - Stripe PaymentElement wrapper
 *
 * Wraps the Stripe PaymentElement with consistent styling
 */

import { PaymentElement } from '@stripe/react-stripe-js';

interface CardSectionProps {
  /** Whether the card element is disabled */
  disabled?: boolean;
  /** Email to prefill in Stripe Link */
  email?: string;
  /** Full name to prefill in billing details */
  name?: string;
}

export function CardSection({ disabled, email, name }: CardSectionProps) {
  return (
    <div className="relative">
      <PaymentElement
        options={{
          layout: 'tabs',
          defaultValues: {
            billingDetails: {
              email: email || undefined,
              name: name || undefined,
            },
          },
          fields: {
            billingDetails: {
              address: {
                postalCode: 'never',
                country: 'never',
              },
            },
          },
          terms: {
            card: 'never',
          },
          wallets: {
            applePay: 'never',
            googlePay: 'never',
          },
        }}
      />
      {disabled && (
        <div className="absolute inset-0 cursor-not-allowed bg-white/50" />
      )}
    </div>
  );
}
